import {
    getQCJobTimespanBlackFrames,
    TimespanMarker,
} from '@pluto/rest';
import {Action, createAction} from 'redux-actions';
import {TimelineMarker} from '../../../Timeline/TimelineTypes';

export const BLACK_FRAMES_SET = 'BLACK_FRAMES_SET';
export const BLACK_FRAMES_RESET = 'BLACK_FRAMES_RESET';

export type SetBlackframesPayload = Promise<TimelineMarker[]>;

export const parseBlackFrame = (blackFrame: TimespanMarker): TimelineMarker => {
    const {
        id,
        startFrameNumber,
        durationFrames,
        createdByUser,
        updatedAt,
    } = blackFrame;
    const start = startFrameNumber;
    const end = startFrameNumber + durationFrames;
    
    return {
        identifier: String(id),
        start,
        end,
        createdByUser,
        updatedAt,
    };
};

export const parseBlackFrames = (blackFrames: TimespanMarker[]): TimelineMarker[] => {
    if (!blackFrames)
        return [];
    
    return blackFrames.map(parseBlackFrame);
};

export const setBlackFramesAction = createAction<SetBlackframesPayload, string, number, number>(BLACK_FRAMES_SET, async (url: string, start: number, end: number): SetBlackframesPayload => {
    try {
        const blackFrames = await getQCJobTimespanBlackFrames(url, {
            start,
            end,
        });
        
        return parseBlackFrames(blackFrames);
    } catch(error) {
        console.error('Failed to load black frames:', error);
        
        return [];
    }
});

export type BlackFramesAction = Action<TimelineMarker[]>;

export const resetBlackFramesAction = createAction<void>(BLACK_FRAMES_RESET);
